import { create } from "zustand"
import { useModalStore } from "../modal"
import { Modal } from "@/shared/types"
import { ProcessCreationLoaderModal } from "@/widgets"


const MAX_LONG_LOADING = 35 * 1000

type InfoPassed = null | "started" | "passed"

type LoadingLength = null | "long" | "short"

interface Store {
	startAppLoading: () => void
	closeAppLoading: () => void

	loadingLength: LoadingLength
	infoPassed: InfoPassed
	setInfoPassed: (infoPassed: InfoPassed) => void
	setLoadingLength: (textLength: number) => void
}

export const useProcessCreationLoadingStore = create<Store>()(set => ({
	loadingLength: null,

	infoPassed: null,
	setInfoPassed: (infoPassed: InfoPassed) => set({ infoPassed }),

	setLoadingLength: (textLength: number) => {
		const loadingLength = textLength >= MAX_LONG_LOADING ? "long" : "short"
		set({ loadingLength })
	},

	startAppLoading: () => {
		useModalStore
			.getState()
			.openModal(Modal.PROCESS_CREATION_LOADING, <ProcessCreationLoaderModal />)
	},
	closeAppLoading: () => {
		set({ loadingLength: null, infoPassed: null })
		useModalStore.getState().closeModal(Modal.PROCESS_CREATION_LOADING)
	},
}))
